// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"6b569005","152":"2c22c43a","198":"99fca25a","345":"e56883c8","362":"e83e6b87","404":"3ac5f455","480":"b3302532","541":"6fbd7d7f","549":"2c9abd0d","579":"cc0a839f","622":"12771674","854":"10515221","930":"bced326f"}[chunkId] + ".chunk.js";
};